/**
 * Solar Savings Calculator JavaScript
 * Handles calculation logic and UI updates
 */

document.addEventListener('DOMContentLoaded', function() {
  const form = document.getElementById('solar-calculator-form');
  
  if (!form) return;

  form.addEventListener('submit', function(e) {
    e.preventDefault();
    calculateSavings();
  });

  function calculateSavings() {
    // Get input values
    const monthlyBill = parseFloat(document.getElementById('monthly-bill').value);
    const roofSize = parseFloat(document.getElementById('roof-size').value);

    if (!monthlyBill || !roofSize) {
      alert('Please fill in all fields');
      return;
    }

    // Get configuration
    const config = window.solarCalculatorConfig || {};
    const electricityRate = config.electricityRate || 1.5;
    const avgSunHours = config.avgSunHours || 5.5;
    const panelEfficiency = config.panelEfficiency || 20;
    const systemCostPerWatt = config.systemCostPerWatt || 15;
    const co2PerKwh = config.co2PerKwh || 0.5;
    const currencySymbol = config.currencySymbol || 'MAD';

    // Calculate current annual consumption in kWh
    const annualConsumption = (monthlyBill * 12) / electricityRate;

    // Calculate potential system size based on roof space
    // Assuming 1 m² = ~150W with modern panels
    const systemSizeKw = (roofSize * 150) / 1000;

    // Calculate annual energy production
    // Formula: System Size (kW) × Sun Hours × 365 × Efficiency Factor
    const efficiencyFactor = (panelEfficiency / 100) * 0.85; // 0.85 accounts for losses
    const annualProduction = systemSizeKw * avgSunHours * 365 * efficiencyFactor;

    // Calculate savings (use the lesser of production or consumption)
    const actualSavingsKwh = Math.min(annualProduction, annualConsumption);
    const annualSavings = actualSavingsKwh * electricityRate;
    const monthlySavings = annualSavings / 12;

    // Calculate CO2 reduction (in tons)
    const co2Reduction = (actualSavingsKwh * co2PerKwh) / 1000;

    // Calculate system cost and payback period
    const systemCost = systemSizeKw * 1000 * systemCostPerWatt;
    const paybackPeriod = systemCost / annualSavings;

    // Update UI
    displayResults({
      annualSavings: annualSavings.toFixed(0),
      monthlySavings: monthlySavings.toFixed(0),
      co2Reduction: co2Reduction.toFixed(1),
      paybackPeriod: paybackPeriod.toFixed(1),
      currencySymbol: currencySymbol
    });
  }

  function displayResults(results) {
    // Hide placeholder, show results
    const placeholder = document.querySelector('.results-placeholder');
    const resultsContent = document.getElementById('results-content');
    
    if (placeholder) placeholder.style.display = 'none';
    if (resultsContent) {
      resultsContent.style.display = 'block';
      
      // Animate results
      resultsContent.style.opacity = '0';
      setTimeout(() => {
        resultsContent.style.transition = 'opacity 0.5s ease';
        resultsContent.style.opacity = '1';
      }, 50);
    }

    // Update values with animation
    animateValue('annual-savings', 0, parseFloat(results.annualSavings), 1000, results.currencySymbol);
    animateValue('monthly-savings', 0, parseFloat(results.monthlySavings), 1000, results.currencySymbol);
    
    // Update CO2 and payback period
    const co2Element = document.getElementById('co2-reduction');
    const paybackElement = document.getElementById('payback-period');
    
    if (co2Element) {
      const co2Text = co2Element.textContent;
      const co2Unit = co2Text.split(' ').slice(1).join(' ');
      animateValue('co2-reduction', 0, parseFloat(results.co2Reduction), 1000, co2Unit);
    }
    
    if (paybackElement) {
      const paybackText = paybackElement.textContent;
      const paybackUnit = paybackText.split(' ').slice(1).join(' ');
      animateValue('payback-period', 0, parseFloat(results.paybackPeriod), 1000, paybackUnit);
    }
  }

  function animateValue(elementId, start, end, duration, suffix = '') {
    const element = document.getElementById(elementId);
    if (!element) return;

    const range = end - start;
    const increment = range / (duration / 16); // 60fps
    let current = start;

    const timer = setInterval(() => {
      current += increment;
      if ((increment > 0 && current >= end) || (increment < 0 && current <= end)) {
        current = end;
        clearInterval(timer);
      }
      
      element.textContent = Math.round(current) + ' ' + suffix;
    }, 16);
  }
});
